export default __webpack_public_path__ + "static/media/image42.343f7459.png";